import type { AnalyticsEventActionType, FilteredWidgetContext, Initiator, VisitorContext } from '@/domain/analytics';

export interface AnalyticsEvent {
  id: string;
  org_id: string;
  action: {
    type: AnalyticsEventActionType;
    value: Record<string, unknown>;
  };
  context: {
    widget: FilteredWidgetContext;
    visitor: VisitorContext;
  };
  initiator: Initiator;
  created_at: string;
  source: typeof SOURCE;
  schema_version: typeof SCHEMA_VERSION;
}

export const SOURCE = 'CHAT_WIDGET' as const;

export const SCHEMA_VERSION = 1 as const;
